import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import * as authTypes from 'modules/auth/actionTypes';
import { LOGIN_STEPS } from 'modules/auth/constant';
import * as usersTypes from 'modules/users/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string | null} */
const initialState = null;

/**
 * Clear error on request
 * @returns {null}
 */
const handleReset = () => null;

/**
 * Set error on failure
 * @param {string | null} state
 * @param {{ payload?: string, error?: string }} action
 * @returns {string | null}
 */
const handleFailure = (state, action) => action.payload ?? action.error ?? null;

/**
 * Clear error on auth step change (LOGIN step)
 * @param {string | null} state
 * @param {import('modules/auth/types').SetAuthStepAction} action
 * @returns {string | null}
 */
const handleSetAuthStep = (state, { type, payload }) => {
  if (type !== authTypes.SET_AUTH_STEP || payload.step === LOGIN_STEPS.LOGIN) {
    return null;
  }
  return state;
};

export default createReducer(initialState, {

  // Clear error on requests
  [authTypes.SIGN_IN_REQUEST]: handleReset,
  [authTypes.IMPERSONATE_USER_ID]: handleReset,
  [authTypes.STOP_IMPERSONATE_USER_ID]: handleReset,
  [authTypes.LOAD_SESSION_REQUEST]: handleReset,
  [usersTypes.CURRENT_USER_DATA_REQUEST]: handleReset,
  [authTypes.SIGN_OUT_REQUEST]: handleReset,

  // Set error on failures
  [authTypes.LOAD_SESSION_FAILURE]: handleFailure,
  [authTypes.SIGN_IN_FAILURE]: handleFailure,
  [authTypes.IMPERSONATE_USER_ID_FAILURE]: handleFailure,
  [authTypes.STOP_IMPERSONATE_USER_ID_FAILURE]: handleFailure,
  [usersTypes.CURRENT_USER_DATA_FAILURE]: handleFailure,
  [authTypes.SIGN_OUT_FAILURE]: handleFailure,

  // Clear on auth step change or emergency
  [USER_LOGOUT_CLEAR]: handleSetAuthStep,
  [authTypes.SET_AUTH_STEP]: handleSetAuthStep,
  [authTypes.SIGN_OUT_EMERGENCY]: handleSetAuthStep,
});
